import { useMemo } from "react";
import { DA_SiteVariant } from "@danishagro/shared/src/interfaces/siteVariant.interface";

export const useMaxValue = (siteVariant: DA_SiteVariant) => {
    const useHighMax = useMemo(
        () =>
            siteVariant.alias === "dla-agro" ||
            siteVariant.alias === "nordic-seed" ||
            siteVariant.alias === "vilofarm",
        [siteVariant.alias]
    );
    return useHighMax;
};
